"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _CodeSplitEnvWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/CodeSplitEnvWrapper"));

var _Tracking = require("pricing-pages-unified-ui/constants/Tracking");

var _MerchandiseIdsToUpgradeProducts = require("self-service-api/constants/MerchandiseIdsToUpgradeProducts");

var MerchCardCTAsContainer = function MerchCardCTAsContainer(props) {
  // TODO: Gotta figure out how to properly get props through
  // TODO: https://product.hubteam.com/docs/frontend/changes/code-splitting.html
  return _react.default.createElement(_CodeSplitEnvWrapper.default, {
    authedComponentLoader: function authedComponentLoader() {
      return import(
      /* webpackChunkName: "authed-chunk" */
      "pricing-pages-unified-ui/components/product-pages/MerchCardAuthedCTAs");
    },
    publicComponentLoader: function publicComponentLoader() {
      return import(
      /* webpackChunkName: "public-chunk" */
      "pricing-pages-unified-ui/components/public-only/MerchCardPublicCTAs");
    },
    authedComponentProps: (0, _extends2.default)({}, props),
    publicComponentProps: (0, _extends2.default)({}, props, {
      sourceId: 'pricing-hero',
      dtbSource: "pricing-page|" + props.hub + "-hub|" + _Tracking.MERCH_CARD + "|" + _MerchandiseIdsToUpgradeProducts.MerchandiseIdsToUpgradeProducts[props.merchandiseId]
    })
  });
};

var _default = MerchCardCTAsContainer;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/MerchCardCTAsContainer.js
// module id = 832
// module chunks = 5 6